// This file is not an actual store, just an example of what store file should look like.

import { ActionTree, MutationTree, Module } from 'vuex';

export type ExampleState = {
	value: string;
};

type ExampleGetter<T> = (state: ExampleState) => T;

export type ExampleGetters = {
	value: ExampleGetter<ExampleState['value']>;
};

export type ExampleStore = {
	state: ExampleState;
	getters: ExampleGetters;
};

const state = () =>
	({
		value: '',
	} as ExampleState);

const getters: ExampleGetters = {
	value(state) {
		return state.value;
	},
};

const actions: ActionTree<ExampleState, void> = {
	async setValue({ commit }, value: ExampleState['value']) {
		commit('SET_VALUE', value);
	},
};

const mutations: MutationTree<ExampleState> = {
	SET_VALUE(state, value: ExampleState['value']) {
		state.value = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<ExampleState, void>;
